import { createRouter, createWebHistory } from 'vue-router'
import Pricing from '../views/Pricing.vue'
import Contact from '../views/Contact.vue'
import About from '../views/About.vue'
import EventApp from '../views/features/EventApp.vue'
import LeadCapture from '../views/features/LeadCapture.vue'
import StyleGuide from '../views/StyleGuide.vue'
import HomePage from '../views/HomePage.vue'
import Components from '../views/Components.vue'
import Blocks from '../views/Blocks.vue'
import StyleGuideSoftware from '../views/StyleGuideSoftware.vue'
import Overview from '../views/Overview.vue'
import BadgesAndKiosks from '../views/features/BadgesAndKiosks.vue'
import AttendanceTracking from '../views/features/AttendanceTracking.vue'
import RegistrationAndTickets from '../views/features/RegistrationAndTickets.vue'
import WebsitesBuilder from '../views/features/WebsitesBuilder.vue'
import AudienceParticipation from '../views/features/AudienceParticipation.vue'
import EmailsAndCommunications from '../views/features/EmailsAndCommunications.vue'
import MeetingsAndNetworking from '../views/features/MeetingsAndNetworking.vue'
import InteractiveFloorplans from '../views/features/InteractiveFloorplans.vue'
import SpeakerPortals from '../views/features/SpeakerPortals.vue'
import CompanyPortals from '../views/features/CompanyPortals.vue'
import PrivacyPolicy from '../views/PrivacyPolicy.vue'
import SupplyTerms from '../views/SupplyTerms.vue'
import FindAPartner from '../views/FindAPartner.vue'
import BecomeAPartner from '../views/BecomeAPartner.vue'
import Partner from '../views/Partner.vue'
import Signup from '../views/Signup.vue'
import MarketingSubPage from '../views/MarketingSubPage.vue'
import { solutionsMenu } from '../data/navSolutionsAndResources.js'
import SectorsAgenciesPco from '../views/solutions/SectorsAgenciesPco.vue'
import SectorsGovernment from '../views/solutions/SectorsGovernment.vue'
import SectorsCorporations from '../views/solutions/SectorsCorporations.vue'
import SectorsAssociations from '../views/solutions/SectorsAssociations.vue'
import TypeTradeshowsExhibitions from '../views/solutions/TypeTradeshowsExhibitions.vue'
import TypeConferencesSeminars from '../views/solutions/TypeConferencesSeminars.vue'
import TypeCorporateEvents from '../views/solutions/TypeCorporateEvents.vue'
import OutcomesDataSecurity from '../views/solutions/OutcomesDataSecurity.vue'
import OutcomesSponsorship from '../views/solutions/OutcomesSponsorship.vue'
import OutcomesAttendeeExperience from '../views/solutions/OutcomesAttendeeExperience.vue'

/** One Vue page per Solutions nav link — paths must stay in sync with `navSolutionsAndResources.js` */
const solutionPageByPath = {
  '/solutions/sectors/agencies-pco': SectorsAgenciesPco,
  '/solutions/sectors/government': SectorsGovernment,
  '/solutions/sectors/corporations': SectorsCorporations,
  '/solutions/sectors/associations': SectorsAssociations,
  '/solutions/type/tradeshows-exhibitions': TypeTradeshowsExhibitions,
  '/solutions/type/conferences-seminars': TypeConferencesSeminars,
  '/solutions/type/corporate-events': TypeCorporateEvents,
  '/solutions/outcomes/data-security': OutcomesDataSecurity,
  '/solutions/outcomes/sponsorship': OutcomesSponsorship,
  '/solutions/outcomes/attendee-experience': OutcomesAttendeeExperience
}

function buildSolutionsRoutes() {
  const routes = []
  for (const section of solutionsMenu) {
    for (const link of section.links) {
      const component = solutionPageByPath[link.to]
      if (!component) {
        throw new Error(`[router] Missing solution page component for path: ${link.to}`)
      }
      routes.push({
        path: link.to,
        name: `Solutions_${link.to.replace(/^\/solutions\//, '').replace(/\//g, '_')}`,
        component,
        meta: {
          title: `${link.label} | Solutions - Entegy`
        }
      })
    }
  }
  return routes
}

const routes = [
  {
    path: '/',
    name: 'Base',
    component: HomePage,
    meta: { title: 'Entegy - Event Management Platform' }
  },
  {
    path: '/styleguide',
    name: 'StyleGuide',
    component: StyleGuide,
    meta: { title: 'Style Guide - Entegy' }
  },
  {
    path: '/styleguide/software',
    name: 'StyleGuideSoftware',
    component: StyleGuideSoftware,
    meta: { title: 'Style Guide - Entegy' }
  },
  {
    path: '/blocks',
    name: 'Blocks',
    component: Blocks,
    meta: { title: 'Blocks - Entegy' }
  },
  {
    path: '/components',
    name: 'Components',
    component: Components,
    meta: { title: 'Components - Entegy' }
  },
  {
    path: '/entegy/web',
    name: 'EntegyWeb',
    component: HomePage,
    meta: { title: 'Entegy - Event Management Platform' }
  },
  {
    path: '/features/eventapp',
    name: 'EventApp',
    component: EventApp,
    meta: { title: 'Event App - Entegy' }
  },
  {
    path: '/features/leadcapture',
    name: 'LeadCapture',
    component: LeadCapture,
    meta: { title: 'Lead Capture - Entegy' }
  },
  {
    path: '/features/badgesandkiosks',
    name: 'BadgesAndKiosks',
    component: BadgesAndKiosks,
    meta: { title: 'Badges & Kiosks - Entegy' }
  },
  {
    path: '/features/attendancetracking',
    name: 'AttendanceTracking',
    component: AttendanceTracking,
    meta: { title: 'Attendance Tracking - Entegy' }
  },
  {
    path: '/features/registrationandtickets',
    name: 'RegistrationAndTickets',
    component: RegistrationAndTickets,
    meta: { title: 'Registration & Tickets - Entegy' }
  },
  {
    path: '/features/websitesbuilder',
    name: 'WebsitesBuilder',
    component: WebsitesBuilder,
    meta: { title: 'Website Builder - Entegy' }
  },
  {
    path: '/features/audienceparticipation',
    name: 'AudienceParticipation',
    component: AudienceParticipation,
    meta: { title: 'Audience Participation - Entegy' }
  },
  {
    path: '/features/emailsandcommunications',
    name: 'EmailsAndCommunications',
    component: EmailsAndCommunications,
    meta: { title: 'Emails & Communications - Entegy' }
  },
  {
    path: '/features/meetingsandnetworking',
    name: 'MeetingsAndNetworking',
    component: MeetingsAndNetworking,
    meta: { title: 'Meetings & Networking - Entegy' }
  },
  {
    path: '/features/interactivefloorplans',
    name: 'InteractiveFloorplans',
    component: InteractiveFloorplans,
    meta: { title: 'Interactive Floorplans - Entegy' }
  },
  {
    path: '/features/speakerportals',
    name: 'SpeakerPortals',
    component: SpeakerPortals,
    meta: { title: 'Speaker Portals - Entegy' }
  },
  {
    path: '/features/companyportals',
    name: 'CompanyPortals',
    component: CompanyPortals,
    meta: { title: 'Company Portals - Entegy' }
  },
  {
    path: '/overview',
    name: 'Overview',
    component: Overview,
    meta: { title: 'Overview - Entegy' }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact,
    meta: { title: 'Contact - Entegy' }
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: { title: 'About - Entegy' }
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy,
    meta: { title: 'Privacy Policy - Entegy' }
  },
  {
    path: '/supply-terms',
    name: 'SupplyTerms',
    component: SupplyTerms,
    meta: { title: 'Supply Terms - Entegy' }
  },
  {
    path: '/find-a-partner',
    name: 'FindAPartner',
    component: FindAPartner,
    meta: { title: 'Find a Partner - Entegy' }
  },
  {
    path: '/become-a-partner',
    name: 'BecomeAPartner',
    component: BecomeAPartner,
    meta: { title: 'Become a Partner - Entegy' }
  },
  {
    path: '/partner/:id',
    name: 'Partner',
    component: Partner,
    meta: { title: 'Partner - Entegy' }
  },
  {
    path: '/signup',
    name: 'Signup',
    component: Signup,
    meta: { title: 'Sign Up for a Free Account - Entegy' }
  },
  {
    path: '/news',
    name: 'NewsUpdates',
    component: MarketingSubPage,
    meta: {
      title: 'News & Updates - Entegy',
      pageTitle: 'News & Updates'
    }
  },
  {
    path: '/case-studies',
    name: 'CaseStudies',
    component: MarketingSubPage,
    meta: {
      title: 'Case Studies - Entegy',
      pageTitle: 'Case Studies'
    }
  },
  ...buildSolutionsRoutes(),
  // Catch-all: unmatched routes go to home
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// Update page title
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Entegy - Event Management Platform'
  next()
})

export default router 